import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Card from 'react-bootstrap/Card';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import AdminClientTransactions from './AdminClientTransactions';
import SuperResellerPassword from './SuperResellerPassword';
import {makeStyles} from "@material-ui/core/styles";
import TotalsChartByName from './TotalsChartByName';


function UpdateSuperReseller(props){

    const [superReseller, setSuperReseller] = useState(
        props.currentSuperReseller
    );
    const [transaction, setTransaction] = useState(0);

    const [credits, setCredits] = useState(1);

    const [description, setDescription] = useState();

    const managerSelector = useSelector((state) => state.superReseller.name);

    useEffect(() => {
        //props.onInitializeSaveClient();
        props.onInitializeSaveSuperReseller();
        props.onGetSuperReseller(props.token, props.currentSuperResellerName);

    }, []);

    useEffect(() => {
        setSuperReseller(props.currentSuperReseller);
        console.log('current super reseller object', superReseller);
    }, [props.currentSuperReseller]);


    useEffect(() => {
        if (props.isErrorSaveSuperReseller){
            var errorMessage = '' + props.isErrorSaveSuperReseller;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorSaveSuperReseller]);

    const handleChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log('name', name);
        console.log('value', value);
        const key = target.key;
        setSuperReseller({
            ...superReseller,
            [name]: value
        })
    };

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    let options = [...Array(100).keys()].slice(1);
    options = [...options, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 2500, 5000, 10000];


    function handleSubmit(event) {
        event.preventDefault();

        const data = {
            name: superReseller.name,
            credits: credits,
            desc: superReseller.description,
            transaction: transaction

        };
        console.log('logging data', data);
        props.onSaveSuperReseller(props.token, data);

    }

    let saveSuperResellerRedirect = null;
    if(props.isSuccessSaveSuperReseller){
        //console.log('redirecting because', props.isSuccessSaveSuperReseller);
        var successMessage = 'Updated ' + props.isSuccessSaveSuperReseller.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        saveSuperResellerRedirect = <Redirect to="/superresellers" />
    }

    // let displayError = null;
    // if (props.isErrorSaveSuperReseller){
    //     //displayError = <Alert variant="danger">{props.isErrorSaveSuperReseller}</Alert>
    //     var errorMessage = '' + props.isErrorSaveSuperReseller;
    //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
    // }

    return (
        <div>
            {saveSuperResellerRedirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={4} xs={12}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Update Super Reseller"
                                            subheader={props.currentSuperReseller.name + ', ' + props.currentSuperReseller.credits + ' Credits'}
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                            subheaderTypographyProps={{
                                                fontSize: 14,
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <form>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-transactions-label">Select Transaction</InputLabel>
                                                    <Select
                                                        id="transaction"
                                                        labelId="Transaction"
                                                        onChange={e => setTransaction(e.target.value)}
                                                        value={0}
                                                    >
                                                        <MenuItem key={0} value={0}>Add</MenuItem>
                                                        <MenuItem key={0} value={1}>Remove</MenuItem>
                                                    </Select>
                                                </FormControl>

                                                <FormControl fullWidth>
                                                    <InputLabel id="select-credits-label">Credits</InputLabel>
                                                    <Select
                                                        id="credits"
                                                        labelId="Credits"
                                                        onChange={e => setCredits(e.target.value)}
                                                        value={credits}
                                                    >
                                                        {options.map(option => {
                                                            return <MenuItem key={option} value={option}>{option}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <FormGroup row>
                                                    <TextField
                                                        id="description"
                                                        name="description"
                                                        value={superReseller.description}
                                                        label="Description"
                                                        onChange={handleChange}
                                                        type="text"
                                                        fullWidth
                                                    />
                                                </FormGroup>
                                            </form>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                block
                                                disabled={props.isLoadingSaveSuperReseller}
                                                type="submit"
                                                onClick={handleSubmit}
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                            >
                                                {props.isLoadingSaveSuperReseller
                                                    ? spinner
                                                    : 'Submit'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Paper>
                            </Grid>
                            <Grid item sm={4} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <SuperResellerPassword />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Transaction History"
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <AdminClientTransactions />
                                        </CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Paper elevation={5}>
                            <TotalsChartByName role="admin" name={managerSelector} />                        
                        </Paper>                           
                    </Grid>
                </Grid>
            </Container>

        </div>
    )

}

const mapDispatchToProps = dispatch => {
    return {
        onGetSuperReseller: (token, name) => dispatch(actions.getSuperReseller(token, name)),
        onInitializeSaveSuperReseller: () => dispatch(actions.initializeSaveSuperReseller()),
        onSaveSuperReseller: (token, data) => dispatch(actions.saveSuperReseller(token, data)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentSuperResellerName: state.superReseller.name,
        currentSuperReseller: state.superReseller.item,
        isLoadingSuperReseller: state.superReseller.loading,
        isErrorSaveSuperReseller: state.saveSuperReseller.error,
        isSuccessSaveSuperReseller: state.saveSuperReseller.super_reseller,
        isLoadingSaveSuperReseller: state.saveSuperReseller.loading

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSuperReseller);